<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="true"
        @close="onFormClose"
        title="Email Group Message"
        :close-on-click-modal="false"
    >
        <loading v-if="isFormBusy"></loading>
        <dialog-form
            v-show="!isFormBusy"
            :get-form-url="getFormUrl"
            :excluded-conversation-ids="excludedConversationIds"
            @formInitialized="onFormInitialized"
            @formInitializationError="onFormInitializationError"
            @created="onCreated"
        ></dialog-form>
    </el-dialog>
</template>

<script>
  import eventBus from "../../event-bus";
  import DialogForm from "./dialog-form.vue";
  import Loading from "../loading";

  export default {
    components: {
      DialogForm,
      Loading,
    },

    props: {
      excludedConversationIds: Array,
    },

    data() {
      return {
        getFormUrl: null,
        isFormBusy: true,
      };
    },

    computed: {
      isDialogVisible() {
        return !_.isNull(this.getFormUrl);
      }
    },

    methods: {
      /**
       * @param {*} url
       */
      showForm(url) {
        this.getFormUrl = url;
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      onFormInitialized() {
        this.isFormBusy = false;
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.isFormBusy = true;
        this.getFormUrl = null;
      },

      /**
       * @param {Object} value
       */
      onFormInitializationError({message}) {
        this.destroyForm();
        message && this.$message.error(message);
      },

      /**
       * @param {Object} value
       */
      onCreated({message}) {
        this.destroyForm();
        message && this.$message.success(message);
        eventBus.$emit('email-bulk-message-created');
      },
    },

    created() {
      eventBus.$on('show-email-bulk-message-dialog', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-email-bulk-message-dialog', this.showForm);
    },
  }
</script>
